import { FC, ReactElement } from "react";
import { Box, Grid, Typography } from "@mui/material";

export const Footer: FC = (): ReactElement => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "auto",
                paddingTop: "1rem",
                paddingBottom: "1rem",
                marginTop: "auto",
                backgroundColor: "#f3f3f3",
            }}
        >
            <Grid container direction="column" alignItems="center">
                <Grid item xs={12}>
                    <Typography variant="subtitle1" fontWeight={600} color='#000000'>
                        {`© ${new Date().getFullYear()} ELVIS Connect. All rights reserved. `}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};
